import { selectFromUserDto } from '../../models';

export default selectFromUserDto()
  .email
  .toString();
